import "@ungap/url-search-params";
import "allsettled-polyfill";
import "array-flat-polyfill";

import * as Sentry from "@sentry/browser";
import {
  REACT_APP__ENVIRONMENT,
  REACT_APP__SENTRY_DSN,
  REACT_APP__VERSION,
} from "@smp/utils";
import { enableMapSet } from "immer";

import { loadFonts } from "@/utils";

import { SENTRY_BLACKLIST_URLS, SENTRY_IGNORE_ERRORS } from "../fixtures";

enableMapSet();

loadFonts(["Roboto"]);

(REACT_APP__ENVIRONMENT === "production" ||
  REACT_APP__ENVIRONMENT === "staging") &&
  Sentry.init({
    autoSessionTracking: false,
    blacklistUrls: SENTRY_BLACKLIST_URLS,
    dsn: REACT_APP__SENTRY_DSN,
    environment: REACT_APP__ENVIRONMENT,
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
    maxBreadcrumbs: 10,
    release: REACT_APP__VERSION,
  });
